var $26da0ba3563bc5d6$exports = {};
$26da0ba3563bc5d6$exports = {
    "loading": `Nalaganje...`,
    "placeholder": `Izberite\u{2026}`
};


export {$26da0ba3563bc5d6$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
